import React from 'react';
import type {Vacancy} from '@rocket-ui/lk-api';
import {Button} from 'ui';
import styles from './OffersTable.module.css';

interface OfferActionCellProps {
	vacancy: Vacancy;
	isApplying: boolean;
	onApply: (vacancy: Vacancy) => void;
}

function AppliedCheckIcon(): React.ReactElement {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none" aria-hidden="true">
			<path d="M0.567383 4.47945L5.62151 9.56445L14.5674 0.564453" stroke="black" strokeWidth="1.6" />
		</svg>
	);
}

function OfferActionCellIcon(): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M10 16V4L18 10L10 16Z" fill="#F3F3F3" />
			<path d="M14 9.19922H2V10.7992H14V9.19922Z" fill="#F3F3F3" />
		</svg>
	);
}

export function OfferActionCell({vacancy, isApplying, onApply}: OfferActionCellProps): React.ReactElement | null {
	if (vacancy.applied) {
		return (
			<div className={styles.actionCell}>
				<span className={styles.appliedStatus}>
					<AppliedCheckIcon />
					<span>Вы откликнулись на это предложение</span>
				</span>
			</div>
		);
	}

	if (vacancy.id == null) return null;

	return (
		<div className={styles.actionCell}>
			<Button
				type="button"
				className={styles.applyButton}
				disabled={isApplying}
				onClick={(event) => {
					event.preventDefault();
					event.stopPropagation();
					onApply(vacancy);
				}}
			>
				Откликнуться
				<span aria-hidden="true">
					<OfferActionCellIcon />
				</span>
			</Button>
		</div>
	);
}
